import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { Flex } from 'antd';
import cn from 'classnames';

import CatalogIcon from 'assets/images/menu/catalog.svg?react';
import HomeIcon from 'assets/images/menu/home.svg?react';
import MoreIcon from 'assets/images/menu/more.svg?react';
import PlannerIcon from 'assets/images/menu/planner.svg?react';
import { EMainRoutes, EYmPageScreen } from 'shared/typings';
import { BottomPanel } from 'shared/ui';
import { sendYmEvent } from 'shared/utils';

import styles from './BottomBar.module.scss';

interface IBottomBarProps extends HTMLAttributes<HTMLDivElement> {}

export const BottomBar: FC<IBottomBarProps> = ({ className, ...props }) => {
	const { t } = useTranslation();

	return (
		<BottomPanel {...props} className={cn(className, styles.bottomBar)}>
			<Flex className={styles.menu} justify="stretch" align="center">
				<NavLink
					to="/"
					onClick={() => sendYmEvent('click_main_screen', { page_screen: EYmPageScreen.MENU_TAB })}
					className={styles.link}>
					<span className={styles.icon}>
						<HomeIcon />
					</span>
					<span>{t('Главная')}</span>
				</NavLink>

				<NavLink
					to={EMainRoutes.CATALOG}
					onClick={() => sendYmEvent('click_catalog', { page_screen: EYmPageScreen.MENU_TAB })}
					className={styles.link}>
					<span className={styles.icon}>
						<CatalogIcon />
					</span>
					<span>{t('Каталог')}</span>
				</NavLink>

				<NavLink
					to={`/${EMainRoutes.PLANNER}`}
					onClick={() => sendYmEvent('click_scheduler', { page_screen: EYmPageScreen.MENU_TAB })}
					className={styles.link}>
					<span className={styles.icon}>
						<PlannerIcon />
					</span>
					<span>{t('Планнер')}</span>
				</NavLink>

				<NavLink to={`/${EMainRoutes.MORE}`} className={styles.link}>
					<span className={styles.icon}>
						<MoreIcon />
					</span>
					<span>{t('Ещё')}</span>
				</NavLink>
			</Flex>
		</BottomPanel>
	);
};
